import { MACRO_KEY } from "../../../defaults";
import { OverviewTemplates as CardsTemplates } from "../../drawers/templates/features/cards/CardsTemplates";
import { OverviewTemplates as PanelsTemplates } from "../../drawers/templates/features/panels/PanelsTemplates";
import { OverviewTemplates as ButtonTemplates } from "../../drawers/templates/features/button/ButtonTemplates";
import { OverviewTemplates as AnnouncementTemplates } from "../../drawers/templates/features/announcements/AnnouncementsTemplates";
import { OverviewTemplates as CountdownTemplates } from "../../drawers/templates/features/countdown/CountdownTemplates";
import { OverviewTemplates as ImageSliderTemplates } from "../../drawers/templates/features/image-slider/ImageSliderTemplates";

export const OVERVIEW_TEMPLATES = [
  {
    macro: MACRO_KEY.CARDS,
    title: "cards",
    link: "view-all-cards",
    Component: CardsTemplates,
  },
  {
    macro: MACRO_KEY.PANEL_SIMPLE,
    title: "panels",
    link: "view-all-panels",
    Component: PanelsTemplates,
  },
  {
    macro: MACRO_KEY.BUTTON_INLINE,
    title: "buttons",
    link: "view-all-buttons",
    Component: ButtonTemplates,
  },
  {
    macro: MACRO_KEY.ANNOUNCEMENTS,
    title: "announcements",
    link: "view-all-announcements",
    Component: AnnouncementTemplates,
  },
  {
    macro: MACRO_KEY.COUNTDOWN,
    title: "countdowns",
    link: "view-all-countdowns",
    Component: CountdownTemplates,
  },
  {
    macro: MACRO_KEY.IMAGE_SLIDER,
    title: "image-sliders",
    link: "view-all-image-sliders",
    Component: ImageSliderTemplates,
  },
];
